import { searchLocations } from "../../requests/locations";
import { LocationInput } from "@qjumpers/common-ui";
import React from "react";

const dummyLocations = [
  { key: "Nelson", displayString: "Nelson" },
  { key: "Wellington City, WGN", displayString: "Wellington City, WGN" },
  { key: "Canterbury", displayString: "Canterbury" },
  { key: "Auckland", displayString: "Auckland" }
];

const mockSearchLocations = (query) => {
  console.log("Mock searchLocations called with query:", query);
  return searchLocations(query)
    .then(res => {
      if (!res || !res.data || res.data.length === 0) {
        console.log("Returning dummy data for local testing...");
        return { data: dummyLocations.filter(d => d.displayString.toLowerCase().includes((query || '').toLowerCase())) };
      }
      return res;
    })
    .catch(err => {
      console.warn("Search API failed, falling back to dummy data:", err);
      return { data: dummyLocations.filter(d => d.displayString.toLowerCase().includes((query || '').toLowerCase())) };
    });
}

const LocationInputWrapper = (props) => {
  return <LocationInput {...props} searchLocations={mockSearchLocations} placeholder="Search location" />;
};
export default LocationInputWrapper;
